export const WHATS_NEW_HREF = '/whats-new';
